import { asVariation } from "../../../helper/variations";
import Pagination from "./component";

Pagination.Primary = asVariation(Pagination, "primary", {
  typeStyle: "primary",
});

export { Pagination };
